export const widgetDetailPage = () =>
  import("./WidgetDetailPage").then((m) => ({ Component: m.WidgetDetailPage }));
